<template>
  <div id="app">
    <h2 id="editor" ref="editor">Please read the following carefully and acknowledge your understanding and agreement by submit Agreed button below.</h2>
    <br />
    <!-- Supplemental Agreement -->

    <v-expansion-panels focusable>
      <v-expansion-panel>
        <v-expansion-panel-header
          >General Notice</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <iframe
            v-if="loadedGeneral"
            :src="fileGeneralURL"
            :style="iframeGeneral.style"
            :height="'100vh'"
            :width="iframeGeneral.style.width"
            type="application/pdf"
            frameborder="0"
          ></iframe>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header
          >Privacy Notice</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <iframe
            v-if="loadedPrivacy"
            :src="filePrivacyURL"
            :style="iframePrivacy.style"
            :height="'100vh'"
            :width="iframePrivacy.style.width"
            type="application/pdf"
            frameborder="0"
          ></iframe>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header
          >Supplemental Agreement</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <iframe
            v-if="loadedPDPA"
            :src="filePDPAURL"
            :style="iframePDPA.style"
            :height="'100vh'"
            :width="iframePDPA.style.width"
            type="application/pdf"
            frameborder="0"
          ></iframe>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header
          >Anti-Bribery and Corruption Policy</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <iframe
            v-if="loadedAnti"
            :src="fileAntiURL"
            :style="iframeAnti.style"
            :height="'100vh'"
            :width="iframeAnti.style.width"
            type="application/pdf"
            frameborder="0"
          ></iframe>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header
          >Supplier Code of Conduct</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <iframe
            v-if="loadedSupplier"
            :src="fileSupplierURL"
            :style="iframeSupplier.style"
            :height="'100vh'"
            :width="iframeSupplier.style.width"
            type="application/pdf"
            frameborder="0"
          ></iframe>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="mt-10" v-if="!$route.params.readonly">
      <v-row align="center" no-gutters>
        <v-spacer></v-spacer>
        <v-col class="shrink">
          <v-btn color="primary" @click="consentPDPA()"> Agreed </v-btn>
        </v-col>
        <!-- <v-divider class="mx-4" vertical></v-divider>
        <v-col class="shrink">
          <v-btn color="primary" outlined> Decline </v-btn>
        </v-col> -->
      </v-row>
    </div>
  </div>
</template>

<script>
import { vendorservice } from "../services/vendorservice";

export default {
  data() {
    return {
      loadedGeneral: false,
      loadedPrivacy: false,
      loadedPDPA: false,
      loadedAnti: false,
      loadedSupplier: false,
      iframeGeneral: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      },
      iframePrivacy: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      },
      iframePDPA: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      },
      iframeAnti: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      },
      iframeSupplier: {
        src: window.location.href,
        style: null,
        wrapperStyle: null,
      },
    };
  },
  mounted() {
    let editor = this.$refs.editor;

    // iframe General
    this.iframeGeneral.style = {
      position: "relative",
      width: "93%",
      height: "100vh",
      top: "0rem",
      left: 0,
      margin: "3rem",
    };
    this.iframeGeneral.wrapperStyle = {
      overflow: "hidden",
      height: "100vh",
      width: editor.clientWidth + "px",
    };
    this.loadedGeneral = true;

    // iframe Privacy
    this.iframePrivacy.style = {
      position: "relative",
      width: "93%",
      height: "100vh",
      top: "0rem",
      left: 0,
      margin: "3rem",
    };
    this.iframePrivacy.wrapperStyle = {
      overflow: "hidden",
      height: "100vh",
      width: editor.clientWidth + "px",
    };
    this.loadedPrivacy = true;

    // iframe PDPA
    this.iframePDPA.style = {
      position: "relative",
      width: "93%",
      height: "100vh",
      top: "0rem",
      left: 0,
      margin: "3rem",
    };
    this.iframePDPA.wrapperStyle = {
      overflow: "hidden",
      height: "100vh",
      width: editor.clientWidth + "px",
    };
    this.loadedPDPA = true;

    // iframe Anti
    this.iframeAnti.style = {
      position: "relative",
      width: "93%",
      height: "100vh",
      top: "0rem",
      left: 0,
      margin: "3rem",
    };
    this.iframeAnti.wrapperStyle = {
      overflow: "hidden",
      height: "100vh",
      width: editor.clientWidth + "px",
    };
    this.loadedAnti = true;

    // iframe Supplier
    this.iframeSupplier.style = {
      position: "relative",
      width: "93%",
      height: "100vh",
      top: "0rem",
      left: 0,
      margin: "3rem",
    };
    this.iframeSupplier.wrapperStyle = {
      overflow: "hidden",
      height: "100vh",
      width: editor.clientWidth + "px",
    };
    this.loadedSupplier = true;
  },
  methods: {
    async consentPDPA() {
      var payload = {
        vendorId: this.$store.state.AppActiveUser.vendorID,
        ipAddress: "",
      };
      localStorage.setItem("isConsent", true);
      await vendorservice.ConsentPDPA(payload).then(() => this.goto(""));
    },

    goto(path) {
      this.$router.push(`/${this.$i18n.locale}/${path}`).catch(() => {});
      // this.$router.go();
    },
  },
  computed: {
    fileGeneralURL() {
      return `/vendor/General-Notice-EN.pdf`;
    },
    filePrivacyURL() {
      return `/vendor/Privacy-Notice-March-2024-EN.pdf`;
    },
    filePDPAURL() {
      return `/vendor/Notice-of-Supplemental-Agreement-EN.pdf`;
    },
    fileAntiURL() {
      if (this.$route.params.lang.toLowerCase() === "th")
        return `/vendor/Anti-Corruption-Policy-TH.pdf`;
      return `/vendor/Anti-Corruption-Policy-EN.pdf`;
    },
    fileSupplierURL() {
      if (this.$route.params.lang.toLowerCase() === "th")
        return `/vendor/Supplier-Code-of-conduct-TH.pdf`;
      return `/vendor/Supplier-Code-of-conduct-EN.pdf`;
    },
  },
};
</script>
